import React from "react";
import styled from "styled-components";
import PromotingTitle from "../Promoting/PromotingTitle";
import Person from "./Person";
import PersonsArray from "./Persons";

const Meet = () => {
  return (
    <Wrapper>
      <PromotingTitle
        boldText="Meet the awesome team behind Spoon. "
        otherText="We’re bridging the gap between the world’s oldest and largest industry and a future where technology can be used to solve our hardest problems."
      />
      <Persons>
        {PersonsArray.map((item) => (
          <Person
            ImageSrc={item.ImageSrc}
            name={item.name}
            description={item.description}
          />
        ))}
      </Persons>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100vw;
  height: auto;

  @media screen and (orientation: portrait) {
    transform: translateY(-18vh);
  }
`;

const Persons = styled.div`
  width: 75vw;
  height: auto;
  margin-left: 12.5vw;
  margin-top: 10vh;

  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  @media screen and (orientation: portrait) {
    margin-left: 0;
    width : 100vw;
  }
`;

export default Meet;
